import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import 'rxjs/add/operator/take';
import {SurveyFilterUIModel, SurveyQuestionFilterRawModel} from '../../../models/survey/survey.model';

@Component({
  selector: 'update-number-range-popup',
  templateUrl: './update-number-range-popup.component.html',
  styleUrls: ['./update-number-range-popup.less']
})
export class UpdateNumberRangeComponent implements OnInit {
  title: string;
  isInvalidFrom = false;
  isInvalidTo = false;
  @Output('close') close = new EventEmitter();
  @Output('submit') submit = new EventEmitter();
  @Input() from: number;
  @Input() to: number;

  constructor() { }

  ngOnInit() { }

  validateInput() {
    this.onChangeFromItem();
    this.onChangeToItem();
  }

  onChangeFromItem() {
    this.isInvalidFrom = this.from == null || this.from < -99999 || this.from > 99999 || this.from > this.to;
  }

  onChangeToItem() {
    this.isInvalidTo = this.to == null || this.to < -99999 || this.to > 99999 || this.from > this.to;
  }

  onClose() {
    this.close.next();
  }

  onClickOkBtn() {
    this.submit.next(`${this.from};${this.to}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/input-number-custom/update-number-range-popup.component.ts